suppliers = {
	init: function() {
		var
			$suppliers = $('.js-suppliers-tab');

		$suppliers.on('click', function() {
			var
				$tab = $(this),
				$buf = $('<div>');

			$buf.load($tab.attr('data-url'), function() {
				$suppliers.filter('.active').removeClass('active');
				$tab.addClass('active');
				$buf = $buf.find('.js-dynamic-content');
				$buf.find('h1').remove();

				$.ajaxSetup({async: false});

				$('.js-suppliers-tab-content')
					.html($buf)
					.find('script').each(function() {
						var
							$script = $(this);

						if ($script.attr('src')) $.getScript($script.attr('src'));
						if ($script.text()) $.globalEval($script.text());
					});

				$.ajaxSetup({async: true});
			})
		});
	}
};



suppliersMenu = {
	init: function() {
		new Swiper('.suppliers-menu .swiper', {
				slidesPerView: 'auto',
				slidesPerGroupAuto: true,
				spaceBetween: 10,
				grabCursor: true,
				navigation: {
				prevEl: '.suppliers-menu__prev',
				nextEl: '.suppliers-menu__next',
			},

			watchOverflow: true
		});
	}
}



$(document).ready(function() {
	suppliers.init();
	suppliersMenu.init();
});

function toggleAccordion(header) {
	const item = header.parentElement;
	const wasActive = item.classList.contains('active');
	document.querySelectorAll('.accordion-item.active').forEach(function(el) {
		el.classList.remove('active');
	});
	if (!wasActive) {
		item.classList.add('active');
	}
}

//Кнопка получить промокод
document.addEventListener('DOMContentLoaded', () => {
	document.addEventListener('click', async (event) => {
		const button = event.target.closest('.js-get-promocode');
		if (!button) return;

		event.preventDefault();

		// Проверяем блокировку
		if (button.classList.contains('is-disabled')) return;

		// Блокируем кнопку
		button.classList.add('is-disabled');
		button.style.pointerEvents = 'none';
		button.textContent = 'Загрузка...';

		try {
			const path = window.location.pathname;
			const match = path.match(/\/([^\/]+)\.html$/);
			const elementCode = match ? match[1] : null;

			const response = await BX.ajax.runComponentAction('planb:supplier', 'getPromocode', {
				mode: 'class',
				data: {
					elementCode: elementCode
				}
			});

			// BX.ajax сам парсит JSON. Успешный ответ лежит в response.data
			if (response.status === 'success' && response.data.status === 'success') {
				const container = button.closest('.js-promocode-container');
				if (container) {
					container.innerHTML = response.data.html;
					clipboard.init();
				}
			} else {
				// Обработка ошибок, пришедших от логики метода
				const errorMsg = response.data?.message || 'Ошибка при получении кода';
				throw new Error(errorMsg);
			}

		} catch (error) {
			console.error('Ошибка AJAX:', error);
			// Если ошибка системная (например, не прошел prefilter или 500 ошибка)
			const alertText = error.errors ? error.errors[0].message : error.message;
			alert(alertText || 'Произошла ошибка. Попробуйте позже.');

			// Разблокировка кнопки при ошибке
			button.classList.remove('is-disabled');
			button.style.pointerEvents = 'auto';
			button.textContent = 'Получить промокод';
		}
	});
});
